import React from 'react';
import "./DashboardDefault.css"
const DashboardDefault = () => {
    return (
        <div className="dashboardMain">
           
            <h1 className="dashboardDefault-header">Visit Our showroom to Buy a super cool Car.</h1>
        </div>
    );
};

export default DashboardDefault;